import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import BookingSuccess from '../pb-payment-details/BookingSuccess';

export class ThankyouPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    try {
      const { status, pnrNumber } = this.props.match.params;
      this.state = {
        status,
        pnrNumber,
      };
    } catch (e) {}
  }

  renderBookingConfirmation = () => {
    if (this.state.status == 'success') {
      return (
        <BookingSuccess
          pnrNumber={this.state.pnrNumber}
          // loading={this.props.common.loadTicketDetailsPending}
          // ticketDetails={this.props.common.ticketDetails}
          history={this.props.history}
          success={true}
          t={this.props.t}
          appType={localStorage.getItem('appType')}
        />
      );
    } else if (this.state.status == 'failure') {
      return <BookingSuccess success={false} />;
    }
  };

  render() {
    return <div className="home-thankyou-page">{this.renderBookingConfirmation()}</div>;
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThankyouPage);



// WEBPACK FOOTER //
// ./src/features/home/ThankyouPage.js